import { Timestamp } from '@angular/fire/firestore';
import { DEFAULT_CURRENCY_CODE } from '../constants/constant-list';
import CurrencyCodes from '../constants/CurrencyCodes';
import CurrencySymbols from '../constants/CurrencySymbols';
import numbro from 'numbro';
import { isEmpty } from 'lodash';
import moment from 'moment';
import {
  Storage,
  ref as StorageRef,
  deleteObject as StorageDeleteObject,
  getDownloadURL,
  uploadBytesResumable,
} from '@angular/fire/storage';

export const formatNumber = (
  amount: number,
  currency: number,
  average: boolean
) => {
  const format = CurrencyCodes?.find(
    (item) => item.NumericCode === Number(currency)
  );
  const AlphabeticCode: any = format?.AlphabeticCode ?? DEFAULT_CURRENCY_CODE;
  const symbols: any = CurrencySymbols[AlphabeticCode];

  let options: any = {
    thousandSeparated: true,
    average,
    optionalMantissa: average,
    mantissa: 2,
    currencyPosition: 'prefix',
  };

  if (format && symbols) {
    options = {
      ...options,
      mantissa: symbols?.decimal_digits,
      currencySymbol: symbols?.symbol,
    };
  }

  return numbro(amount).formatCurrency(options);
};

export const formatCurrency = (
  amount: number,
  currency: string,
  average = false,
  currencyPosition?: 'prefix' | 'infix' | 'postfix'
) => {
  // const format = CurrencyCodes?.find(
  //   item => item.AlphabeticCode === Number(currency),
  // );
  const symbols = CurrencySymbols[currency];
  let options: any = {
    thousandSeparated: true,
    abbreviations: {
      thousand: 'K',
      million: 'M',
      billion: 'B',
      trillion: 'T',
    },
    average,
    optionalMantissa: average,
    mantissa: 2,
    currencyPosition: currencyPosition ?? 'prefix',
  };

  if (symbols) {
    options = {
      ...options,
      mantissa: symbols?.decimal_digits,
      currencySymbol: symbols?.symbol,
    };
  }
  const returnAmt = numbro(Number(amount)).formatCurrency(options);
  return returnAmt;
};

export const dateFS = (timestamp: Timestamp) => {
  if (!isEmpty(timestamp)) {
    const jsDate = timestamp?.toDate?.();
    return moment(new Date(jsDate)).format('DD MMM YYYY - hh:mm A');
  } else {
    return '';
  }
};

export function unlinkFileToFirebase(
  storage: Storage,
  path: string
): Promise<boolean> {
  return new Promise(async (resolve, reject) => {
    try {
      const ref = StorageRef(storage, path);
      await StorageDeleteObject(ref);
      resolve(true);
    } catch (e) {
      reject(e);
    }
  });
}

export function uploadFileToFirebase(
  storage: Storage,
  {
    uri,
    path,
  }: {
    uri: string;
    path: string;
  }
): Promise<{ resultURI: string | null }> {
  return new Promise(async (resolve, reject) => {
    try {
      let resultResize = { uri };
      const response = await fetch(resultResize.uri);
      const blob = await response.blob();
      const storageRef = StorageRef(storage, path);
      const uploadTask = uploadBytesResumable(storageRef, blob);

      uploadTask.on(
        'state_changed',
        (snapshot) => {
          if (snapshot.state === 'success') {
            getDownloadURL(storageRef).then((resultURI) => {
              resolve({ resultURI });
            });
          }
        },
        (error: any) => {
          reject(error);
        },
        async () => {
          const url = await getDownloadURL(storageRef);
          resolve({ resultURI: url });
        }
      );
    } catch (e) {
      reject(e);
    }
  });
}

export const toQueryParams = (obj: any) => {
  const params = new URLSearchParams();
  for (const key in obj) {
    const value = obj[key];
    if (Array.isArray(value)) {
      params.append(key, value.join(','));
    } else {
      params.append(key, value);
    }
  }
  const result = params.toString();

  return result;
};
